/*
 * @Description: AppStore
 * @Author: Yongchao Wang
 * @Date: 2021-07-03 17:13:29
 * @LastEditors: Yongchao Wang
 * @LastEditTime: 2021-07-05 19:50:51
 */
import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import Reducer from './reducer';

export const AppContext = createContext();

/**
 * @description: 仓库
 * @param {*} children
 * @return {*}
 * @author: Yongchao Wang
 */
function Store({ children }) {
  const { initState, dispatch } = Reducer();

  return (
    <AppContext.Provider value={{ initState, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}
Store.propTypes = {
  children: PropTypes.element,
};

Store.defaultProps = {
  children: (<div />),
};


export default Store;

